import ExtensionEventType from 'owa-service/lib/contract/ExtensionEventType';
import isExtensibilityContextInitialized from 'owa-addins-store/lib/store/isExtensibilityContextInitialized';
import isExtensibilityContextAvailable from 'owa-addins-store/lib/store/isExtensibilityContextAvailable';
import getExtensionEventByType from 'owa-addins-store/lib/utils/getExtensionEventByType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function shouldForceOnSendCompliantBehavior(): boolean {
    const context = isExtensibilityContextAvailable();
    const isInitialized = isExtensibilityContextInitialized();
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2532 (13,27): Object is possibly 'undefined'.
    // @ts-expect-error
    const policyEnabled = getUserConfiguration().SegmentationSettings.OnSendAddinsEnabled;

    if (context && isInitialized) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (19,9): Type 'boolean | undefined' is not assignable to type 'boolean'.
        // @ts-expect-error
        return policyEnabled && getExtensionEventByType(ExtensionEventType.ItemSend).length > 0;
    } else {
        // ExtensibilityContext failed to load or is still loading force anyway
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (25,9): Type 'boolean | undefined' is not assignable to type 'boolean'.
        // @ts-expect-error
        return policyEnabled;
    }
}
